<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h1 class="toc_head">CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/004_Acknowledge#ack">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/005_Introduction#intro">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/006_Chapter_1#chapter1">1921–1929</a></h2>
<h2 class="toc"><span href="#/xhtml/007_Chapter_2#chapter2" title="Link target outside of Sample">1930–1939</span></h2>
<h2 class="toc"><span href="#/xhtml/008_Chapter_3#chapter3" title="Link target outside of Sample">1940–1949</span></h2>
<h2 class="toc"><span href="#/xhtml/009_Chapter_4#chapter4" title="Link target outside of Sample">1950–1959</span></h2>
<h2 class="toc"><span href="#/xhtml/010_Chapter_5#chapter5" title="Link target outside of Sample">1960–1969</span></h2>
<h2 class="toc"><span href="#/xhtml/011_Chapter_6#chapter6" title="Link target outside of Sample">1970–1979</span></h2>
<h2 class="toc"><span href="#/xhtml/012_Chapter_7#chapter7" title="Link target outside of Sample">1980–1989</span></h2>
<h2 class="toc"><span href="#/xhtml/013_Chapter_8#chapter8" title="Link target outside of Sample">1990–1999</span></h2>
<h2 class="toc"><span href="#/xhtml/014_Chapter_9#chapter9" title="Link target outside of Sample">2000–2009</span></h2>
<h2 class="toc"><span href="#/xhtml/015_final#final" title="Link target outside of Sample">The Final Years: 2010–2014 <em class="italic"></em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?fc961904